document.addEventListener('DOMContentLoaded', () => {

    const svg = document.querySelector('.circle')

    if( svg ) {
        initProgress(svg)
    }

})

function initProgress(svg) {

    const circle = svg.querySelector('.progress')

    const containerCircle = document.querySelector('.progress-container')

    const parent = svg.closest('.attenuation-container')

    const tds = parent.querySelectorAll('table [data-value]')

    const radius = circle.getBoundingClientRect().width

    let rotationCircle = 0

    const start = 0

    const end = 180

    const circumference = 1 * Math.PI * radius

    // circle.style.strokeDasharray = `${circumference}`

    // circle.style.strokeDashoffset = `${circumference}`

    let isLockedCircle = false

    let rotationActive = false;

    let lastScrollY = window.scrollY;

    let scrollDirection = null;

    let oldPercent

    let startY = 0;

    let endY = 0;

    let lockedDown = false


    const observerCircle = new MutationObserver(toggleScrollLockCircle);

    observerCircle.observe(document.body, { attributes: true, attributeFilter: ['style'] });

    toggleScrollLockCircle();


    window.addEventListener('wheel', (e) => {

        if (!isLockedCircle) return;

        e.preventDefault();

        const delta = e.deltaY > 0 ? 5 : -5;

        updateRotation(delta);

    }, { passive: false });

    // Optional: touch support
    let lastTouchY = null;

    window.addEventListener('touchstart', (e) => {
        lastTouchY = e.touches[0].clientY;
        startY = lastTouchY
    });

    window.addEventListener('touchmove', (e) => {

        if (!isLockedCircle) return;

        e.preventDefault();

        const currentY = e.touches[0].clientY;

        const deltaY = lastTouchY - currentY;

        const delta = deltaY > 0 ? 1 : -1

        checkScrollLockTrigger();

        updateRotation(delta, true);
        lastTouchY = currentY;
    }, { passive: false });


    window.addEventListener('touchend', function (e) {
        endY = e.changedTouches[0].clientY;
        handleSwipe();
    });

    window.addEventListener('scroll', () => {

        scrollDirection = window.scrollY > lastScrollY ? 'down' : 'up';

        lastScrollY = window.scrollY;

        checkScrollLockTrigger();
    });

    function toggleScrollLockCircle() {
        isLockedCircle ? document.body.classList.add('hidden-circle') : document.body.classList.remove('hidden-circle')
    }


    function handleSwipe() {

        const diffY = startY - endY;

        scrollDirection = diffY > 0 ? 'down' : 'up'

        checkScrollLockTrigger()
    }


    function checkScrollLockTrigger() {

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        const isDesktop = window.innerWidth >= 992

        const menuHeight = document.getElementById('header-main-menu').offsetHeight

        const element = isDesktop ? containerCircle : svg.closest('.attenuation-container')

        const offsetTop = element.offsetTop

        if (scrollDirection === 'down' && isElementTopAtOrAboveViewport(element) && lockedDown === false && rotationCircle >= start) {

            isLockedCircle = true;

            rotationActive = true;

            if (rotationCircle !== start) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'auto';
            }

            if (scrollTop > offsetTop) {

                window.scrollTo({
                    top: offsetTop + menuHeight,
                    behavior: 'smooth',
                });

            }

        }

        if (scrollDirection === 'up' && isElementBelowViewport(element) && lockedDown === true && rotationCircle <= end) {

            isLockedCircle = true;
            rotationActive = true;

            if (rotationCircle !== end) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'auto';
            }

            if (scrollTop > offsetTop) {

                window.scrollTo({
                    top: offsetTop + menuHeight,
                    behavior: 'smooth',
                });

            }

        }

    }



    

    function isElementTopAtOrAboveViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top <= 0 && rect.bottom > 0;
    }


    function isElementBelowViewport(el) {
        const rect = el.getBoundingClientRect();
        const bottom = rect.bottom - rect.height
        return rect.top >= 0 && bottom >= 0
    }



    function updateRotation(delta, mobile = false) {

        if (!rotationActive) return;

        if (mobile) {
            delta = delta * 10
        }

        rotationCircle += delta;

        // Clamp between start and end
        const min = 0

        const max = 180

        if (rotationCircle >= max) {
            rotationCircle = max;
            isLockedCircle = false;
            lockedDown = true
            document.body.style.overflow = 'auto';

            containerCircle.classList.remove('in-view')
            const percent = rotationCircle / 180 * 100
            // setProgressCircle(percent)
            tds.forEach(td => {
                setProgressText(td, percent)
            })
            return;
        }

        if (rotationCircle <= min) {
            rotationCircle = min;
            isLockedCircle = false;
            lockedDown = false

            document.body.style.overflow = 'auto';
            containerCircle.classList.remove('in-view')
            const percent = rotationCircle / 180 * 100
            console.log('percent', percent)
            // setProgressCircle(percent)
            tds.forEach(td => {
                setProgressText(td, percent)
            })
            return;
        }

        isLockedCircle = true;

        containerCircle.classList.add('in-view')

        document.body.style.overflow = 'hidden';

        const percent = rotationCircle / 180 * 100

        console.log('percent', percent)

        // setProgressCircle(percent)

        tds.forEach(td => {
            setProgressText(td, percent)
        })

    }

    // function setProgressCircle(percent) {

    //     const offset = circumference - (percent / 100) * circumference

    //     circle.style.strokeDashoffset = offset

    // }

    function setProgressText(el, percent) {

        const max = el.dataset['value'] ?? 0

        const calculated = Math.round(max / 100 * percent)

        const unit = el.dataset['unit'] ?? ''

        if( scrollDirection === 'down' ) {
            el.textContent = Math.min(calculated, max) + ' ' + unit
        } else {
            el.textContent = Math.max(calculated, 0) + ' ' + unit

        }



        

    }


}